module.exports = __webpack_public_path__ + "static/img/20211012_3.96dd7a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2021/20211012_3.png
// module id = fpLh
// module chunks = 0